export const categoryList = [
  {
    key: "电视剧",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "家庭情感、都市职场、古装权谋、悬疑推理，追剧不迷路。",
  },
  {
    key: "电影",
    name: "电影",
    icon: "ri-film-line",
    desc: "悬疑犯罪、爱情文艺、励志剧情，大银幕的精彩一网打尽。",
  },
  {
    key: "综艺",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "美食竞技、户外真人秀、音乐竞演，轻松下饭的快乐之源。",
  },
];

export const genreOptions = ["全部", "家庭情感", "都市职场", "年代情感", "古装权谋", "悬疑推理", "悬疑犯罪", "爱情文艺", "励志剧情", "情景喜剧", "美食竞技", "户外真人秀", "音乐竞演"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022"];

export const regionOptions = ["全部", "中国大陆"];

export const sortOptions = [
  { key: "latest", name: "最新上线" },
  { key: "popular", name: "最热播" },
  { key: "rating", name: "评分最高" },
];